import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { Button, Grid, makeStyles, withStyles } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader.js";
import CustomeTextField from "components/UpdateUi/CustomeTextField.js";
import ToastModal from "views/components/ToastModal";
import styles from "assets/jss/material-dashboard-react/views/modalStyle";
import brandTheme from "brandTheme/Theme";
import BottomButton from "components/CustomButtons/BottomButton";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import { adminPannelData } from "assets/properties/properties";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import ConfirmationModal from "views/components/ConfirmationModal";
const style = () => ({
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 2%",
    maxWidth: "29.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  header: {
    fontSize: brandTheme.headerFontSize,
    fontWeight: 700,
    lineHeight: "1.5rem",
    fontFamily: brandTheme.font.poppins,
    margin: "2% 2% 0px 2%",
  },
  inputContainer: {},
  label: {
    fontSize: "1.2rem",
    marginLeft: ".3rem",
    marginTop: "1.1rem",
    color: brandTheme.labelColor,
    "&:focus,&:visited,&": {
      position: "absolute",
      fontSize: ".7rem",
      color: brandTheme.black,
      marginTop: "-0.4rem",
      zIndex: "1",
      background: "white",
    },
  },
  nextButton: {
    boxShadow: "inherit",
    color: brandTheme.white,
    margin: "10px 10px 10px 0 ",
    letterSpacing: "1px",
    height: "40px",
    // width:"8%",
    padding: "0px 40px",
    width: "100px",
    backgroundColor: brandTheme.buttonColor,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
    "&:focus": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
  },
  nextButton1: {
    boxShadow: "inherit",
    color: brandTheme.white,
    margin: "10px 10px 10px 0 ",
    padding: "0px 40px",
    height: "40px",
    // width:"8%",
    width: "100px",
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
    "&:focus": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
  },
  verifyButton: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: 0,
  },
  nextButton3: {
    boxShadow: "inherit",
    color: brandTheme.white,
    padding: "0px 40px",
    height: "40px",
    width: "8%",
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
    "&:focus": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
  },
  ButtomButtonContainer: {
    maxWidth: "1200px",
    margin: "45px auto 0px",
  },
});
const useStyles = makeStyles(style);
const AdminPanel = ({ editable }) => {
  const classes = useStyles();
  const [loanApplicationNumber, setLoanApplicationNumber] = useState("");
  const [loanApplicationNumberState, setLoanApplicationNumberState] =
    useState("");
  const [loanId, setLoanId] = useState("");
  const [loanIdState, setLoanIdState] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumberState, setMobileNumberState] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [loanAPPLICATIONID, setLoanAPPLICATIONID] = useState("");
  const [showSearchBox, setShowSearchBox] = useState(false);

  const [selectedTableData, setSelectedTableData] = useState([]);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const SearchParam = () => {
    let query = "";
    if (loanId !== "") {
      if (query !== "") query = query + "&";
      query = query + "loanApplicationId=" + loanId?.trim();
    }
    if (loanApplicationNumber !== "") {
      if (query !== "") query = query + "&";
      query =
        query +
        "loanApplicationNumber=" +
        loanApplicationNumber?.toUpperCase().trim();
    }

    return query;
  };
  const GetAuctionData = async (type) => {
    const query = SearchParam();
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.APPLICATION_SEARCH + query,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result.data.error_code) {
      toastUpdate("Error", "No records found", true);
    } else {
      if (result.data.length === 0) {
        toastUpdate("Error", "No records found", true);
        setShowSearchBox(false);
      } else {
        console.log(result.data);
        if (result.data) {
          parseIndicatorData(result.data);
          if(type === "show"){
          setShowSearchBox(true);
          }else{
            setShowSearchBox(false)
          }
        }
      }
    }
  };
  const showDeleteResponse = (loanApplicationId) => {
    setConfirmationModalHeader("Reject Application");
    setConfirmationModalMsg("Are you sure you want to Reject this entry");
    setConfirmationModal(true);
    setLoanAPPLICATIONID(loanApplicationId);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setLoanAPPLICATIONID("");
  };
  const handlePositiveResponse = async () => {
    let id = loanAPPLICATIONID;
    handleNegativeResponse();
    // Call API to delete loanMarking
      onClickDeleteData(loanAPPLICATIONID);
  };

  const UnAssignPacketNumber = async (loanApplicationId) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.UNASSIGN_PACKETS,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Loan application rejected successfully", true);
      GetAuctionData('hide');
    }
  };
  const onClickDeleteData = async (id) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.SANCTION_STATUS_UPDATE,
      method: "PUT",
      authToken: authToken,
      data: {
        loanApplicationId: id,
        status: "REJECTED",
      },
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
        UnAssignPacketNumber(id)
    }
  };
  const GetAction = (loanApplicationId, applicationStatus) => {
    return (
      applicationStatus !== "COMPLETED" && applicationStatus !== "REJECTED" && (
        <>
          <Button
            aria-label="Delete Disbursal"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              showDeleteResponse(loanApplicationId);
            }}
          >
            Reject
          </Button>
          {/* )} */}
        </>
      )
    );
  };
  const parseIndicatorData = (data) => {
    let reportData = [];
    let row = {
      leadid: data.loanApplicationId,
      created: data.createdBy,
      formNumber: data.loanApplicationNumber,
      accountNumber: data.loanAccountNumber,
      customerid: data.customerId,
      mobile: data.mobileNumber?.trim(),
      status: data.status,
      action: GetAction(data?.loanApplicationId, data.status),
    };
    console.log(data, row, "asdkhakdhk");
    reportData.push(row);
    setSelectedTableData(reportData);
  };
  const ValidateSearch = () => {
    if (loanId === "" && loanApplicationNumber === "") {
      toastUpdate("Error", "Please fill required field", true);
      return false
    }else{
      return true
    }
  };
  const searchData = () => {
    if (ValidateSearch()) {
      GetAuctionData('show');
      // setShowSearchBox(true);
    }
  };
  const clearResultData = () => {
    setShowSearchBox(false);
  };
  const clearData = () => {
    setLoanId("");
    setLoanApplicationNumber("");
  };
  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader label="Reject Application" />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Loan Application Number"
              required
              id="Applicant_name"
              error={loanApplicationNumberState}
              value={loanApplicationNumber?.toUpperCase() || ""}
              setState={setLoanApplicationNumber}
              disabled={editable}
              setError={setLoanApplicationNumberState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Loan Id"
              required
              id="father_name"
              error={loanIdState}
              value={loanId || ""}
              setState={setLoanId}
              setError={setLoanIdState}
              disabled={editable}
            />
          </Grid>
          {/* <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Mobile Number"
             required
             id="mother_name"
             error={mobileNumberState}
             value={mobileNumber || ""}
             setState={setMobileNumber} 
             setError={setMobileNumberState}
             disabled= {editable}
             />
         </Grid> */}
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        className={classes.ButtomButtonContainer}
      >
        <BottomButton
          button1="Search"
          button2="Clear"
          button3="Clear Result"
          button1click={searchData}
          button2click={clearData}
          button3click={clearResultData}
        />
      </Grid>
      {showSearchBox && (
        <Grid item xs={12} sm={12} md={12}>
          <ColumnGroupingTable
            columns={adminPannelData}
            rows={selectedTableData}
          />
        </Grid>
      )}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

AdminPanel.propTypes = {
  editable: PropTypes.object,
};

export default withStyles(styles)(AdminPanel);
